export default "__VITE_ASSET__582d1200__"